import React, { useEffect, useState, useRef } from "react";
import { RiAdminFill } from "react-icons/ri";
import { ImPlus } from "react-icons/im";
import pages from "../index";
import { Collapse } from "reactstrap";
import {
  ScrollArea,
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Avatar,
  AvatarImage,
  useToast,
} from "../../components/ui";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";
import { Header } from "../../components/modules";
import { FaTimes, FaCheckCircle } from "react-icons/fa";
import { FiFileText } from "react-icons/fi";
import Context from "../../Context";
import { IoMdTrash } from "react-icons/io";
import { MdPersonSearch } from "react-icons/md";
import { Spinner } from "reactstrap";
import { statuses } from "../../constants";
import { CSVLink, CSVDownload } from "react-csv";
import { thaiDate, role } from "../../util";
import { DatePicker, Spin } from "antd";
import th from "antd/es/date-picker/locale/th_TH";
import dayTh from "dayjs/locale/th";
import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";

dayjs.extend(buddhistEra);
dayjs.locale(dayTh);

const buddhistLocale = {
  ...th,
  lang: {
    ...th.lang,
    fieldDateFormat: "DD-MM-BBBB",
    fieldDateTimeFormat: "DD-MM-BBBB HH:mm:ss",
    yearFormat: "BBBB",
    cellYearFormat: "BBBB",
  },
};

export const ReportOrderDiscount = () => {
  const downloadRef = useRef(null);
  const { toast } = useToast();
  const { callApi, configs, profileState } = Context();
  const [orders, setOrders] = useState(false);
  const [selectedRoundDate, setSelectedRoundDate] = useState(configs.roundDate);
  const [selectedStatus, setSelectedStatus] = useState(false);
  const [selectDate, setSelectedDate] = useState();
  const [reportType, setReportType] = useState("roundDate");
  const [selectedPaymentChannel, setSelectedPaymentChannel] = useState(false);
  const [loading, setLoading] = useState(false);

  const [csvFileName, setCsvFileName] = useState("");
  const [csvData, setCsvData] = useState([]);
  const [downloaded, setDownloaded] = useState([]);

  useEffect(() => {
    if (csvFileName && !downloaded.includes(csvFileName)) {
      downloadRef.current.childNodes[0].click();
      setDownloaded((old) => [...old, csvFileName]);
    }
  }, [csvFileName]);

  const getOrders = async () => {
    setLoading(true);

    let startAtId = "";
    let limit = 5000;

    const [adminDiscountOrder = [], couponDiscountOrder = []] =
      await Promise.all([
        callApi(
          "orders-getAll",
          {
            queries: [
              ["isAdminChangePrice", true],
              ["status", statuses.APPROVE],
            ],
            limit,
            startAfter: startAtId,
            roundDate: selectedRoundDate,
            orderBy: ["createdAt", "desc"],
          },
          { notShowLoading: true }
        ),
        callApi(
          "orders-getAll",
          {
            queries: [
              ["coupon.status", "==", statuses.APPROVE],
              ["status", statuses.APPROVE],
            ],
            limit,
            startAfter: startAtId,
            roundDate: selectedRoundDate,
            orderBy: ["createdAt", "desc"],
          },
          { notShowLoading: true }
        ),
      ]);

    setLoading(false);
    setOrders(
      [...adminDiscountOrder, ...couponDiscountOrder]
        .filter((x) => x.coupon?.coupon?.type !== "reserve")
        .sort((a, b) => b.createdAt - a.createdAt)
    );
  };

  const handleDownload = async () => {
    const result = orders.map((order, index) => [
      index + 1,
      new Date(order.createdAt).toLocaleDateString("th-TH", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      }),
      order.shortId,
      order.firstName + " " + order.lastName + " #" + order.userId,
      order.deliverChannel,
      order.size,
      order?.totalPriceBeforeDiscount?.toLocaleString(),
      order.totalPrice?.toLocaleString(),
      order.approverName + ` #${order.approver}`,
      order.reasonChangePrice || order.coupon?.coupon?.name || "-",
    ]);
    result.unshift([
      "ลำดับ",
      "วัน-เวลา",
      "รหัสคำสั่งซื้อ",
      "ชื่อ-นามสกุล #รหัสผู้ใช้",
      "ช่องทางการซื้อ",
      "จำนวนใบ",
      "ราคาก่อนลด",
      "ราคาหลังลด",
      "ผู้เปลี่ยนราคาและอนุมัติ	",
      "หมายเหตุ",
    ]);
    setCsvData(result);
    setCsvFileName(`รายงานคำสั่งซื้อสลากเปลี่ยนราคา_${selectedRoundDate}.csv`);
  };

  return (
    <div className="h-fit w-full max-w-[1600px] mb-24">
      {/* header */}
      <Header
        header="Report"
        subHeader="รายงานคำสั่งซื้อสลากเปลี่ยนราคา"
        icon={<FiFileText className="text-blue" />}
      />

      <div className="relative w-96 bg-white rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
        <div className="p-3 border-b border-gray-300">
          <p className="font-semibold ">รายงานคำสั่งซื้อสลากเปลี่ยนราคา</p>
        </div>
        <div className="grid grid-cols-2 items-center gap-3 p-3 ">
          <div className="gap-2 col-span-2">
            <p className="font-medium text-xs">งวด</p>
            <div>
              <select
                className="border-2 w-full h-9 border-gray-300 rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
                value={selectedRoundDate}
                onChange={(e) => setSelectedRoundDate(e.target.value)}
              >
                {configs.roundDates.map((roundDate) => (
                  <option key={roundDate} value={roundDate}>
                    {roundDate}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {/* <div className="gap-2">
            <p className="font-medium text-xs">รูปแบบรายงาน</p>
            <div>
              <select
                className="border-1 w-full h-9 border-gray-300 rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
                value={reportType}
                onChange={(e) => {
                  setReportType(e.target.value);
                }}
              >
                <option value={"roundDate"}>ทั้งงวด</option>
                <option value={"date"}>รายวัน </option>
              </select>
            </div>
          </div>
          <div>
            <p className="font-medium text-xs">สถานะ</p>
            <div className="flex">
              <DatePicker
                className="border-1 w-full border-gray-300 h-9 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm disabled:cursor-not-allowed"
                locale={buddhistLocale}
                disabled={reportType === "roundDate"}
                value={selectDate ? dayjs(selectDate, "YYYY-MM-DD") : false}
                onChange={(en, th) => {
                  const selectedDate =
                    th.split("-")[2] -
                    543 +
                    "-" +
                    th.split("-")[1] +
                    "-" +
                    th.split("-")[0];

                  setSelectedDate(selectedDate);
                }}
              />
            </div>
          </div>
          <div className="gap-2">
            <p className="font-medium text-xs">สถานะ</p>
            <div>
              <select
                className="border-1 w-full border-gray-300 h-9 rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
                value={selectedStatus}
                onChange={(e) => {
                  console.log(e.target.value);
                  setSelectedStatus(e.target.value);
                }}
              >
                <option value={""}>ทั้งหมด</option>
                <option value={statuses.APPROVE}>อนุมัติ </option>
                <option value={statuses.PAID}>จ่ายแล้ว</option>
                <option value={statuses.PENDING}>รอจ่าย</option>
                <option value={statuses.CANCEL}>ยกเลิก</option>
              </select>
            </div>
          </div>
          <div className="gap-2">
            <p className="font-medium text-xs">รูปแบบการชำระ</p>
            <div>
              <select
                className="border-1 w-full border-gray-300 h-9 rounded-lg cursor-pointer disabled:cursor-not-allowed disabled:opacity-65"
                value={selectedPaymentChannel}
                onChange={(e) => setSelectedPaymentChannel(e.target.value)}
              >
                <option value={""}>ทั้งหมด</option>
                <option value={"qr"}>QR </option>
                <option value={"bank"}>แนบสลิป</option>
              </select>
            </div>
          </div> */}
          <button
            disabled={loading}
            className="flex items-center justify-center gap-1 py-2 px-3 bg-blue text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:opacity-60"
            onClick={() => {
              getOrders();
            }}
          >
            {loading ? (
              <Spinner className="w-3 h-3" />
            ) : (
              <MdPersonSearch className="text-white" />
            )}
            ค้นหา
          </button>
          <button
            disabled={!orders.length}
            className="flex items-center justify-center gap-1 py-2 px-3 bg-[rgb(59,176,101)] text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-300 disabled:hover:opacity-100 disabled:cursor-not-allowed"
            onClick={() => {
              handleDownload();
            }}
          >
            {/* {loading ? (
              <Spinner className="w-3 h-3" />
            ) : (
              <MdPersonSearch className="text-white" />
            )} */}
            ดาวโหลด
          </button>
        </div>
      </div>
      <div ref={downloadRef}>
        <CSVLink
          data={csvData}
          filename={csvFileName}
          style={{ display: "none" }}
        >
          Download me
        </CSVLink>
      </div>
      {/* admins */}
      {orders && (
        <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
          <div className="flex bg-white gap-3 items-center p-3 border-b border-gray-300">
            <p className="font-semibold ">คำสั่งซื้อทั้งหมด</p>{" "}
            <p className="text-xs font-semibold text-[#969797]">
              {orders.length} คำสั่งซื้อ
            </p>
          </div>
          {/* <ScrollArea className={`h-96`}> */}
          <Table>
            <TableHeader className={`bg-[#f2f3f5]`}>
              <TableRow>
                <TableHead className="">วันที่-เวลา</TableHead>
                <TableHead className="text-center">รหัสคำสั่งซื้อ</TableHead>
                <TableHead className="">ชื่อ-นามสกุล ผู้ซื้อ</TableHead>
                <TableHead className="text-center">ช่องทางการซื้อ</TableHead>
                <TableHead className="text-center">จำนวนสลาก</TableHead>
                <TableHead className="text-center">ราคา</TableHead>
                <TableHead>ผู้เปลี่ยนราคาและอนุมัติ</TableHead>
                <TableHead className="text-right">หมายเหตุ</TableHead>
                {/* <TableHead>ผู้ยกเลิก</TableHead> */}
              </TableRow>
            </TableHeader>

            <TableBody className={``}>
              {orders.length > 0 ? (
                orders.map((order) => {
                  return (
                    <TableRow key={order.shortId}>
                      <TableCell className={`font-medium`}>
                        {new Date(order.createdAt).toLocaleDateString("th-TH", {
                          year: "numeric",
                          month: "numeric",
                          day: "numeric",
                          hour: "numeric",
                          minute: "numeric",
                        })}{" "}
                        น.
                      </TableCell>
                      <TableCell className="font-medium text-center">
                        {order.shortId}
                      </TableCell>
                      <TableCell className={""}>
                        {order.firstName +
                          " " +
                          order.lastName +
                          " #" +
                          order.userId}
                      </TableCell>
                      <TableCell className={"text-center"}>
                        {order.deliverChannel}
                      </TableCell>
                      <TableCell className="font-medium text-center">
                        {order.size}
                      </TableCell>
                      <TableCell className="font-medium text-center">
                        {order.totalPrice} (
                        <s style={{ lineHeight: "15px" }}>
                          {order?.totalPriceBeforeDiscount?.toLocaleString()}
                        </s>
                        )
                      </TableCell>
                      <TableCell className="font-medium  ">
                        {order.approverName + ` #${order.approver}`}
                      </TableCell>
                      <TableCell className="font-medium text-right">
                        {order.reasonChangePrice ||
                          order.coupon?.coupon?.name ||
                          "-"}
                      </TableCell>
                      {/* <TableCell>{order.cancelerName}</TableCell> */}
                    </TableRow>
                  );
                })
              ) : (
                <TableCell className="" colSpan="6">
                  <div className="min-h-52 w-full flex justify-center items-center font-medium text-[#969797]">
                    <div>
                      <MdPersonSearch className="text-white" />
                      ไม่พบคำสั่งซื้อ
                    </div>
                  </div>
                </TableCell>
              )}
            </TableBody>
          </Table>
          {/* </ScrollArea> */}
        </div>
      )}
    </div>
  );
};
